// eslint-disable-next-line import/no-extraneous-dependencies
import styled from "styled-components";

// Got this from :https://codepen.io/SH-Shafi/pen/zYrRMYP
// Super cool loader
export const FullScreenLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.25);
  height: 100dvh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .loader {
    position: relative;
    width: 10vw;
    height: 5vw;
    padding: 1.5vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader span {
    position: absolute;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background-color: black;
  }

  .loader span:nth-child(1) {
    animation: loading-dotsA 0.5s infinite linear;
  }

  .loader span:nth-child(2) {
    animation: loading-dotsB 0.5s infinite linear;
  }

  @keyframes loading-dotsA {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(20px);
    }
    50% {
      transform: none;
    }
    75% {
      transform: translateY(20px);
    }
    100% {
      transform: none;
    }
  }

  @keyframes loading-dotsB {
    0% {
      transform: none;
    }
    25% {
      transform: translateX(-20px);
    }
    50% {
      transform: none;
    }
    75% {
      transform: translateY(-20px);
    }
    100% {
      transform: none;
    }
  }
`;
